<template>
  <div>
    <ul>
      <li>
        <input :id="fiveStarId" type="checkbox" name="star" :value="5" v-model="fiveStar" @change="radioSelected(5)" />
        <label :for="fiveStarId"><span class="icon"><i class="fas fa-star"></i></span>&nbsp;5</label>
      </li>
      <li>
        <input :id="fourStarId" type="checkbox" name="star" :value="4" v-model="fourStar" @change="radioSelected(4)" />
        <label :for="fourStarId"><span class="icon"><i class="fas fa-star"></i></span>&nbsp;4</label>
      </li>
      <li>
        <input :id="threeStarId" type="checkbox" name="star" :value="3" v-model="threeStar" @change="radioSelected(3)" />
        <label :for="threeStarId"><span class="icon"><i class="fas fa-star"></i></span>&nbsp;3</label>
      </li>
      <li>
        <input :id="twoStarId" type="checkbox" name="star" :value="2" v-model="twoStar" @change="radioSelected(2)" />
        <label :for="twoStarId"><span class="icon"><i class="fas fa-star"></i></span>&nbsp;2</label>
      </li>
      <li>
        <input :id="oneStarId" type="checkbox" name="star" :value="1" v-model="oneStar" @change="radioSelected(1)" />
        <label :for="oneStarId"><span class="icon"><i class="fas fa-star"></i></span>&nbsp;1</label>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    name: 'StarRatingFilter',
    props: {
      defaultStar: {
        type: Number,
        default: 5
      }
    },
    data () {
      return {
        uid: null,
        currentRadio: this.defaultStar,
        starList: [5, 4, 3, 2, 1],
        oneStar: false,
        twoStar: false,
        threeStar: false,
        fourStar: false,
        fiveStar: false
      }
    },
    mounted () {
      this.uid = this._uid
    },
    computed: {
      fiveStarId () {
        return `${this.uid}_fiveStar`
      },
      fourStarId () {
        return `${this.uid}_fourStar`
      },
      threeStarId () {
        return `${this.uid}_threeStar`
      },
      twoStarId () {
        return `${this.uid}_twoStar`
      },
      oneStarId () {
        return `${this.uid}_oneStar`
      }
    },
    methods: {
      radioSelected (index) {
        let selectedStars = []
        if (this.fiveStar) {
          selectedStars.push(5)
        }
        if (this.fourStar) {
          selectedStars.push(4)
        }
        if (this.threeStar) {
          selectedStars.push(3)
        }
        if (this.twoStar) {
          selectedStars.push(2)
        }
        if (this.oneStar) {
          selectedStars.push(1)
        }
        this.$emit('changed', selectedStars)
      }
    }
  }
</script>
<style type="text/scss" scoped>
  .columns {
    max-width: 450px;
  }

  ul li {
    list-style: none;
    display: inline-block;
  }

  ul > li:nth-child(1) > input:not(:checked) ~ label > .icon {
    color: #17BE86;
  }
  ul > li:nth-child(2) > input:not(:checked) ~ label > .icon {
    color: #60c3a7;
  }
  ul > li:nth-child(3) > input:not(:checked) ~ label > .icon {
    color: #fbbb4e;
  }
  ul > li:nth-child(4) > input:not(:checked) ~ label > .icon {
    color: #f89b58;
  }
  ul > li:nth-child(5) > input:not(:checked) ~ label > .icon {
    color: #f05645;
  }

  label {
    padding: 10px 13px;
    width: 40px;
    color: #58595B;
    background-color: #F5F5F5;
    cursor: pointer;
    position: relative;
    z-index: 2;
    overflow: hidden;

    &:before {
      width: 10px;
      height: 10px;
      content: '';
      position: absolute;
      opacity: 0;
      z-index: -1;
    }

    &:after {
      width: 32px;
      height: 32px;
      content: '';
      border: 2px solid #D1D7DC;
      background-color: #444;
      z-index: 2;
      position: absolute;
      cursor: pointer;
    }
  }

  label {
    margin-right: 14px;
    font-size: 0.9rem;
  }

  input:checked ~ label {
    color: #fff;

    &:before {
      opacity: 1;
    }
  }

  ul > li:nth-child(1) > input:checked ~ label {
    background-color: #17BE86;
  }
  ul > li:nth-child(2) > input:checked ~ label {
    background-color: #60c3a7;
  }
  ul > li:nth-child(3) > input:checked ~ label {
    background-color: #fbbb4e;
  }
  ul > li:nth-child(4) > input:checked ~ label {
    background-color: #f89b58;
  }
  ul > li:nth-child(5) > input:checked ~ label {
    background-color: #f05645;
  }

  input:checked ~ label > .icon {
    color: #fff;
  }

  input {
    width: 32px;
    height: 32px;
    order: 1;
    z-index: 2;
    position: absolute;
    right: 30px;
    top: 50%;
    cursor: pointer;
    visibility: hidden;
  }

  @media screen and (max-width: 767px) {
    label {
      margin-right: 7px;
      padding: 4px 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/StarRadioFilter.vue